var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"v-data-table__mobile-row"},[_c('div',{staticClass:"v-data-table__mobile-row__header"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"v-data-table__mobile-row__cell"},[_vm._v(_vm._s(_vm.montant))])])
}
var staticRenderFns = []

export { render, staticRenderFns }